<template>
  <div>
    <div class="row columns is-multiline">
      <div class="column is-full">
        <vertical-card :item="item"></vertical-card>
      </div>

      <div class="column is-full" v-if="item.buybox">
        <h2
          class="heading is-size-3 box has-text-centered is-uppercase"
        >zobacz oferty innych sklepów</h2>
        <BuyBoxWidget :bbId="item.buybox.bbId" :productNumber="item.buybox.productNumber"></BuyBoxWidget>
      </div>
      <div class="column is-full">
        <h2 class="heading is-size-3 box has-text-centered is-uppercase">zobacz również</h2>
      </div>
    </div>
    <cards-list :items="items" :filter="item"></cards-list>
    <hr />
    <articles-teaser :limit="4" />
  </div>
</template>

<script>
import ArticlesTeaser from "./ArticlesTeaser";
import Card from "./Card";
import CardsList from "./CardsList";
import database from "../database.json";
import VerticalCard from "./VerticalCard";
import BuyBoxWidget from "./BuyBoxWidget";

export default {
  name: "ItemDetail",
  components: { VerticalCard, CardsList, ArticlesTeaser, BuyBoxWidget },
  metaInfo() {
    return {
      meta: [
        // general
        { name: "description", content: this.metaDescription },

        // Schema.org for Google
        { itemprop: "name", content: this.metaTitle },
        { itemprop: "description", content: this.metaDescription },
        { itemprop: "image", content: this.metaImageSrc },

        // twitter
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: this.metaTitle },
        { name: "twitter:description", content: this.metaDescription },
        { name: "twitter:image:src", content: this.metaImageSrc },

        // Open Graph general (Facebook, Pinterest & Google+)
        { property: "og:title", content: this.metaTitle },
        { property: "og:description", content: this.metaDescription },
        { property: "og:image", content: this.metaImageSrc },
        { property: "og:image:url", content: this.metaImageSrc },
        { property: "og:image:width", content: 650 * 2 },
        { property: "og:image:height", content: 341 * 2 },

        { property: "og:image:alt", content: this.metaTitle },
        { property: "og:url", content: this.metaUrlContent },
        { property: "og:locale", content: "pl_PL" },
        { property: "og:type", content: "link" },

        // Open Graph - Product (e-commerce)
        { property: "product:price:currency", content: "PLN" },
        { property: "product:price:amount", content: this.metaPrice },
        { property: "product:brand", content: "United States Mint" },
      ],
      title: this.metaTitle,
      description: this.metaDescription,
      titleTemplate: "NA CO CI TO? - %s",
    };
  },
  computed: {
    metaImageSrc() {
      return this.item.image_src_jpg;
    },
    metaTitle() {
      return this.item.meta_title;
    },
    metaDescription() {
      return this.item.meta_description;
    },
    metaPrice() {
      return this.item.price;
    },
    metaUrlContent() {
      return `https://nacocito.pl/${this.item.slug}/`;
    },
  },
  methods: {
    setPage() {
      this.item = database.find((item) => item.slug == this.$route.params.slug);
    },
  },
  watch: {
    "$route.fullPath"() {
      this.setPage();
    },
  },
  beforeMount() {
    this.setPage();
  },
  data() {
    return {
      items: database,
      item: null,
    };
  },
};
</script>
